import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import Icon from '~/components/icon/icon';
import styles from './styles.css';

export class ReportsPage extends Component {
  render() {
    const { upcomingBrewCustomsReport } = this.props;

    return (
      <Page>
        <TitleBar title="Reports" />
        <Card className="content pa3">
          <ul className="pa0 ma0 list grid grid-1-column grid-2-column-m grid-3-column-l gutter-column-1 gutter-row-1">
            {upcomingBrewCustomsReport && (
              <li>
                <Link to={`reports/upcomingbrews`}>
                  <div className={`flex ${styles.setting} pa2 br1`}>
                    <Icon icon="reports" className={`mr3 ${styles.icon}`} />
                    <div>
                      <h5 className="ma0 mb1">Upcoming brews</h5>
                      <p className="ma0">View historical customs reports for upcoming brews</p>
                    </div>
                  </div>
                </Link>
              </li>
            )}
            <li>
              <Link to={`reports/brewtransfer`}>
                <div className={`flex ${styles.setting} pa2 br1`}>
                  <Icon icon="reports" className={`mr3 ${styles.icon}`} />
                  <div>
                    <h5 className="ma0 mb1">Brew transfer notification</h5>
                    <p className="ma0">View historical customs reports for brew transfer notifications</p>
                  </div>
                </div>
              </Link>
            </li>
            <li>
              <Link to={`reports/completedbrewtransfer`}>
                <div className={`flex ${styles.setting} pa2 br1`}>
                  <Icon icon="reports" className={`mr3 ${styles.icon}`} />
                  <div>
                    <h5 className="ma0 mb1">Completed brew transfer notification</h5>
                    <p className="ma0">View historical customs reports for completed brew transfer notifications</p>
                  </div>
                </div>
              </Link>
            </li>
          </ul>
        </Card>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    upcomingBrewCustomsReport: state.brewery.country.upcomingBrewCustomsReport
  };
}

export default connect(mapStateToProps)(ReportsPage);



// WEBPACK FOOTER //
// ./src/pages/reports/reports.jsx